/** Trigger a browser file download from a Blob. */
export function saveBlobAsFile(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function safeDownloadName(title: string, fallback = "material") {
  const cleaned = title.replace(/[^\w\s-]/g, "").trim();
  return `${cleaned || fallback}.pdf`;
}
